import type { Speaker } from '../hooks/useSpeakersQuery'

function addSpeaker(speakers: Speaker[], speaker: Speaker): Speaker[] {
  return [...speakers, speaker]
}

function updateSpeaker(
  speakers: Speaker[],
  speakerPredicate: (speaker: Speaker) => boolean,
  speakerProperties: Partial<Speaker>
): Speaker[] {
  const speakerIndex = speakers.findIndex(speakerPredicate)

  if (speakerIndex === -1) {
    return speakers
  }

  const speaker: Speaker = { ...speakers[speakerIndex], ...speakerProperties }

  return [
    ...speakers.slice(0, speakerIndex),
    speaker,
    ...speakers.slice(speakerIndex + 1),
  ]
}
function removeSpeaker(
  speakers: Speaker[],
  speakerPredicate: (speaker: Speaker) => boolean
): Speaker[] {
  const speakerIndex = speakers.findIndex(speakerPredicate)

  if (speakerIndex === -1) {
    return speakers
  }

  return [
    ...speakers.slice(0, speakerIndex),
    ...speakers.slice(speakerIndex + 1),
  ]
}

export { addSpeaker, updateSpeaker, removeSpeaker }
